import axios from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchExtensaos(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/extensao/findAll', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchExtensao(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/extensao/findOne/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchExtensaoCampos(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/extensaoCampos/findCamposByTb/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addExtensao(ctx, regraData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/extensao/create', regraData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    inserirExtensaoCampo(ctx, extensaoCampoValor) {
      return new Promise((resolve, reject) => {
        axios
          .post('/extensaoCampos/create', extensaoCampoValor)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    putExtensao(ctx, regraData) {
      return new Promise((resolve, reject) => {
        axios
          .put('/extensao/update', regraData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateExtensaoCampo(ctx, extensaoCampoValor) {
      return new Promise((resolve, reject) => {
        axios
          .put('/extensaoCampos/update', extensaoCampoValor)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    removeExtensao(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/extensao/delete/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    removeExtensaoCampo(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/extensaoCampos/delete/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

  },
};
